// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.

export function initializeAutocomplete(optionsId) {
  // Read dropdown options from hidden field
  const separator = '||';
  const availableOptions = document.getElementById(optionsId);
  const optionsArray = availableOptions.value.split(separator).map(option => option.trim());

  const autoCompleteJS = new window.autoComplete({
    placeHolder: "Search",
    data: {
      src: optionsArray,
      cache: true,
    },
    resultItem: {
      highlight: true,
    },
    resultsList: {
      maxResults: Infinity, // Show unlimited results
      // Set a max-height to make the dropdown scrollable
      element: (list, data) => {
        list.setAttribute("style", `max-height: 200px;`);
      },
    },
    trigger: () => true, // Always return true to trigger the engine
    events: {
      input: {
        selection: (event) => {
          const selection = event.detail.selection.value;
          autoCompleteJS.input.value = selection;
        },
      },
    },
  });

  var inputElement = document.getElementById("autoComplete");

  // Manually start suggestions on input click
  inputElement.addEventListener("click", function () {
    autoCompleteJS.input.dispatchEvent(new Event("input"));
  });
}

export function fadeFetchButton(buttonText) {
  const button = document.querySelector('.button-primary__active');

  if (!button) {
    console.warn('fadeFetchButton: button with class .button-primary__active not found');
    return;
  }

  button.innerHTML = buttonText;
  button.classList.remove("fade-button");

  // Remove any existing click listeners by cloning the element
  const newButton = button.cloneNode(true);
  button.parentNode.replaceChild(newButton, button);

  // Add fresh click event listener
  newButton.addEventListener("click", function () {
    this.innerHTML = "Fetching...";
    this.classList.add("fade-button");
  });
}

export function closeAlerts() {
  $(document).on('click', '.close-message', function () {
    $(this).parent('.flash-message').fadeOut(200, function () {
      $(this).remove();
    });
  });
}
